"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnHeader = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const table_columns_1 = require("../../table-columns");
const icons_1 = require("../../../../icons");
const getColumnHeader = (id, options) => {
    const { isAIEnrichedOverride } = options || {};
    const { dataMeta: { isAIEnriched, isMeasure }, } = (0, table_columns_1.parseColumnId)(id);
    const shouldShowSparkle = isAIEnrichedOverride !== undefined
        ? isAIEnrichedOverride
        : (isAIEnriched || isMeasure);
    const additionalProps = {
        titleIcon: shouldShowSparkle ? react_1.default.createElement(icons_1.AISparkleIcon, { fill: ui_components_1.baseColors.blue300 }) : undefined,
    };
    const HeaderComponent = (params) => react_1.default.createElement(ui_components_1.ColumnHeader, Object.assign(Object.assign({}, params), additionalProps));
    HeaderComponent.displayName = 'HeaderComponent';
    return HeaderComponent;
};
exports.getColumnHeader = getColumnHeader;
